import { SeanceReportActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { successType } from 'src/services/api-handlers/api-resolver';

export interface GetSeanceReportsAction {
    type: typeof SeanceReportActions.FETCH_SEANCE_REPORTS;
    payload: any;
    all?: any;
}

export function getSeanceReports(params: any): GetSeanceReportsAction {
    return {
        type: SeanceReportActions.FETCH_SEANCE_REPORTS,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getSeanceReportsCsv(params: QueryParamsAll): GetSeanceReportsAction {
    return {
        type: SeanceReportActions.FETCH_SEANCE_REPORTS_CSV,
        payload: params,
    };
}

export function getSeanceReportsTotal(params: QueryParamsAll): GetSeanceReportsAction {
    return {
        type: SeanceReportActions.FETCH_SEANCE_REPORTS_TOTAL,
        payload: params,
    };
}
export function clearTotal(): any {
    return {
        type: successType(SeanceReportActions.FETCH_SEANCE_REPORTS_TOTAL),
        payload: {},
        total: true,
    };
}

export interface GetSeanceReportAction {
    type: typeof SeanceReportActions.FETCH_SEANCE_REPORT;
    payload: {
        id: string | number;
    };
}

export function getSeanceReport(id: string | number): GetSeanceReportAction {
    return {
        type: SeanceReportActions.FETCH_SEANCE_REPORT,
        payload: { id },
    };
}

export interface DeleteSeanceReportAction {
    type: typeof SeanceReportActions.DELETE_SEANCE_REPORT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteSeanceReport(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteSeanceReportAction {
    return {
        type: SeanceReportActions.DELETE_SEANCE_REPORT,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetSeanceReportsAction | GetSeanceReportAction | DeleteSeanceReportAction;
